import type { Model } from '@patsnap/tahiti-core';
import type { Paragraph } from '../../paragraph-editor/type';

export interface SplitEditorState {
    editingParagraph: Paragraph | undefined;
}

export const SplitEditorModel = Symbol.for('SplitEditorModel');

export interface SplitEditorModel extends Model<SplitEditorState> {}
